import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { ICourseForUser } from '.';

export type TGetCourseAsUser = {
  id: string;
  isSubSectionsAllowed?: boolean;
};

export type TGetCoursesForUser = {
  limit: number;
  offset: number;
  searchText?: string;
  enrolment?: 'ENROLLED' | 'UNENROLLED';
};

const apiDataProvider = new APIDataProvider();

const getCoursesForUsersModule = async (data: TGetCoursesForUser) => {
  let path = `${ApiPaths.courses}?limit=${data.limit}&offset=${data.offset}`;

  if (data.searchText) {
    path += `&searchText=${data.searchText}`;
  }

  if (data.enrolment) {
    path += `&enrolment=${data.enrolment}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ICourseForUser>>
  >(path);

  return response.data;
};

export const getEnrolmentCoursesForUsers = createAsyncThunk(
  '/user/courses/enrolment-list',
  getCoursesForUsersModule
);

export const loadMoreEnrolmentCoursesForUsers = createAsyncThunk(
  '/user/courses/enrolment-loadMore',
  getCoursesForUsersModule
);

export const getNonEnrolmentCoursesForUsers = createAsyncThunk(
  '/user/courses/non-enrolment-list',
  getCoursesForUsersModule
);

export const loadMoreNonEnrolmentCoursesForUsers = createAsyncThunk(
  '/user/courses/non-enrolment-loadMore',
  getCoursesForUsersModule
);

export const getCourseByIdForUsers = createAsyncThunk(
  '/user/courses/getOne',
  async (data: TGetCourseAsUser) => {
    let path = `${ApiPaths.courses}/${data.id}`;

    if (data.isSubSectionsAllowed) {
      path += `?subSections=1`;
    }

    const response = await apiDataProvider.get<TApiResponse<ICourseForUser>>(
      path
    );

    return response.data;
  }
);
